export default "__VITE_ASSET__f2daeedd__"